import ua from 'ua'
import queue from 'queue'
import event from 'event'
import qs from 'qs'

var q = queue(function (data) {
  if (ua.isPiaoniu()) {
    Bridge._exec(data.method, data.args, data.callback)
  }
})

var dequeueTimeout = null
var dequeue

if (process.browser) {
  dequeue = window.PNJSBridgeDequeue = function () {
    clearTimeout(dequeueTimeout)
    dequeueTimeout = null
    q.dequeue()
  }
}

var Bridge = {
  _exec: function (method, params, callback) {
    var callbackName = this.registerCallback(callback)
    var iframe = document.createElement('iframe')
    iframe.onload = iframe.onerror = removeNode
    iframe.src = 'js://_?method=' + method + '&params=' + encodeURIComponent(JSON.stringify(params)) + '&callback=' + callbackName
    document.body.appendChild(iframe)
    iframe.style.display = 'none'

    function removeNode () {
      iframe.onload = iframe.onerror = null
      iframe.parentNode && iframe.parentNode.removeChild(iframe)
    }
    setTimeout(removeNode, 1000)
  },
  registerCallback: function (callback) {
    var callbackName = 'PNJSCallback_' + (+new Date()) + '_' + Math.floor(Math.random() * 50)
    window[callbackName] = callback
    return callbackName
  },
  exec: function (method, params) {
    if (!ua.isPiaoniu()) {
      return new Promise((resolve, reject) => {})
    }
    for (var k in params) {
      params[k] = typeof params[k] == 'number'
        ? String(params[k])
        : params[k]
    }

    console.log('<bridge>:', method, JSON.stringify(params))
    if (ua.isDebug()) {
      return new Promise(function (resolve, reject) {
        $.ajax({
          url: 'http://localhost:1943',
          dataType: 'jsonp',
          data: {
            method: method,
            params: JSON.stringify(params)
          },
          success: function (data) {
            return resolve(data)
          },
          error: function (xhr, errorType, error) {
            reject(new Error(errorType))
          }
        })
      })
    } else {
      var p = new Promise(function (resolve, reject) {
        q.push({
          method: method,
          args: params,
          callback: function (result) {
            result = result || {}
            var error
            if ('error' in result) {
              error = new Error(result.error)
              reject(error)
              Bridge.onerror(error)
              p.emit('error', error)
            } else {
              p.emit('done', result)
              resolve(result)
            }
          }
        })
        dequeueTimeout = setTimeout(function () {
          dequeue()
        }, 1000)
      })

      event.mixin(p)
      return p
    }
  }
}

Bridge.onerror = function (err) {
  console.log('uncaughtPromiseError', err)
}

Bridge.share = function (params) {
  if (params.imgUrl.indexOf('//') == 0) {
    params.imgUrl = 'http:' + params.imgUrl
  }
  return Bridge.exec('share', params)
}

Bridge.assureLogin = function (callback) {
  return Bridge.exec('assureLogin').then(callback)
}

Bridge.initShare = function (params) {
  if (!params.link) {
    params.link = location.href
  }
  return Bridge.exec('initShare', params)
}

Bridge.setTitle = function (title) {
  return Bridge.exec('setTitle', {
    title: title
  })
}

Bridge.shareTo = function (params) {
  return Bridge.exec('shareTo', params)
}

Bridge.saveImage = function (params) {
  return Bridge.exec('saveImage', params)
}

Bridge.payOrder = function (orderId) {
  return Bridge.exec('payOrder', {
    orderId: orderId + ''
  })
}

Bridge.toast = function (message, delay) {
  return Bridge.exec('toast', {
    message,
    delay
  })
}

Bridge.back = function () {
  return Bridge.exec('back')
}

Bridge.back.isAvailable = function () {
  return ua.isPiaoniu()
}

Bridge.subscribe = function (key, callback) {
  return Bridge.exec('subscribe', {
    key: key
  }).then(callback)
}

Bridge.publish = function (key, data) {
  return Bridge.exec('publish', {
    key: key,
    data: data
  })
}

Bridge.setBackgroundColor = function (color) {
  return Bridge.exec('setBackgroundColor', {
    color: color
  })
}

Bridge.setRightButton = function (text, handler) {
  return Bridge.exec('setRightButton', {
    text: text,
    callbackId: Bridge.registerCallback(handler)
  })
}

Bridge.setUser = function (data) {
  return Bridge.exec('setUser', data)
}

Bridge.addCalendarEvent = function (data) {
  return Bridge.exec('addCalendarEvent', data)
}

Bridge.setContentHeight = function (height) {
  return Bridge.exec('setContentHeight', {
    height: height
  })
}

Bridge.gotoNativeScheme = function (url, params) {
  let protocol = 'piaoniu://'
  if (url.indexOf(protocol) == -1) {
    url = protocol + url
  }
  let iframe = document.createElement('iframe')
  let iframeSrc = url
  if (params) {
    iframeSrc = url + '?' + qs.stringify(params)
  }

  if (ua.isAndroid()) {
    iframe.setAttribute('src', iframeSrc)
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    setTimeout(() => {
      iframe.parentNode.removeChild(iframe)
      iframe = null
    })
  } else {
    location.href = iframeSrc
  }
}

Bridge.gotoFlutterScheme = function (url, params) {
  let protocol = 'piaoniuflutter://'
  if (url.indexOf(protocol) == -1) {
    url = protocol + url
  }
  let iframe = document.createElement('iframe')
  let iframeSrc = url
  if (params) {
    iframeSrc = url + '?' + qs.stringify(params)
  }

  if (ua.isAndroid()) {
    iframe.setAttribute('src', iframeSrc)
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    setTimeout(() => {
      iframe.parentNode.removeChild(iframe)
      iframe = null
    })
  } else {
    location.href = iframeSrc
  }
}

Bridge.selectCoupon = function (data) {
  return Bridge.exec('selectCoupon', data)
}

module.exports = Bridge



// WEBPACK FOOTER //
// ./src/mods/bridge.js